<cc-settings-block [ngClass]="'form-container'">
  <cc-settings-header
    [ngStyle]="{borderBottom: 'none'}"
    header="{{ 'WEBHOOKS.NEW' | translate }}">
  </cc-settings-header>
  <cc-settings-body>
    <div>
      <span translate="DEVELOPERS.WEBHOOKS_INFO"></span>
      &nbsp;<a target="_blank" href="https://developers.channels.app" translate="DEVELOPERS.READ_MORE" class="text-info"></a>
    </div>

    <br />

    <form [formGroup]="webhookForm">

      <cc-settings-row class="webhook-form-row" *ngIf="multipleSubjectTypesAvailable()">
        <p translate>WEBHOOKS.TYPE</p>
        <mat-radio-group formControlName="subjectType"
                         [disabled]="!!existingId"
                         (change)="changeType()">
          <mat-radio-button value="PROJECT">
            {{'WEBHOOKS.GLOBAL' | translate }}
          </mat-radio-button>
          <mat-radio-button value="MSISDN">
            {{'WEBHOOKS.PER_NUMBER' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </cc-settings-row>

      <cc-settings-row class="webhook-form-row" *ngIf="canSelectMsisdn()">
        <p translate>PHONE_NUMBER</p>

        <cc-msisdn-dropdown
          [firstItemDefault]="true"
          [msisdns]="msisdns$ | async"
          controlName="entityId"
          [form]="webhookForm"
        >
        </cc-msisdn-dropdown>
      </cc-settings-row>


      <cc-settings-row class="webhook-form-row">
        <p translate>WEBHOOKS.EVENT_TYPE</p>

        <div class="relativeWrapper">
          <mat-select placeholder="{{ 'WEBHOOKS.CHOOSE_TYPE'| translate}}" formControlName="types" multiple>
            <mat-select-trigger>
              <span translate [translateParams]="{number: webhookForm.get('types')?.value?.length}">WEBHOOKS.N_CHOOSEN</span>
            </mat-select-trigger>

            <mat-option
              *ngFor="let eventType of eventTypesToSelect"
              [value]="eventType.value"
            >
              {{ eventType.name }}
            </mat-option>
          </mat-select>
          <cc-input-errors
            [form]="webhookForm"
            inputName="types"
            [errors]="[{'required':'ERRORS.REQUIRED'}]"
          ></cc-input-errors>
        </div>
      </cc-settings-row>

      <cc-settings-row class="webhook-form-row">
        <p translate>WEBHOOKS.NAME</p>
        <cc-input-label-error-wrapper
          placeholder="{{ 'WEBHOOKS.ENTER_THE_NAME'| translate}}"
          [form]="webhookForm"
          controlName="name">
        </cc-input-label-error-wrapper>
      </cc-settings-row>

      <cc-settings-row class="webhook-form-row">
        <p translate>WEBHOOKS.EXTERNAL_LINK</p>
        <cc-input-label-error-wrapper
          placeholder="{{ 'WEBHOOKS.TYPE_URL'| translate}}"
          [form]="webhookForm"
          controlName="endpoint"
        >
        </cc-input-label-error-wrapper>
      </cc-settings-row>


      <div class="buttons-wrapper">
        <button
          (click)="cancel()"
          mat-raised-button
          type="button"
          color="info-full">
          {{'CANCEL' | translate}}
        </button>
        <button
          (click)="save($event)"
          mat-raised-button
          type="submit"
          color="primary-full">
          {{'SAVE' | translate}}
        </button>
      </div>
    </form>

  </cc-settings-body>


</cc-settings-block>
